<template>
  <v-navigation-drawer
    id="core-navigation-drawer"
    v-model="drawer"
    :expand-on-hover="expandOnHover"
    :src="barImage"
    mobile-break-point="960"
    app
    mini-variant-width="80"
    width="260"
    v-bind="$attrs"
  >
    <template v-slot:img="props">
      <v-img :gradient="`to bottom, ${barColor}`" v-bind="props" />
    </template>

<!--    <v-list-item two-line>-->
<!--      <v-list-item-content>-->
<!--        <v-list-item-title class="text-uppercase font-weight-regular display-2">-->
<!--          <span class="logo-mini">VH</span>-->
<!--          <span class="logo-normal">CRM</span>-->
<!--        </v-list-item-title>-->
<!--      </v-list-item-content>-->
<!--    </v-list-item>-->

    <div style="padding-top: 12px; text-align: right;">
      <img
          :width="isHover ? 65 : 95"
          :height="isHover ? 15 : 22"
          class="mr-2"
          src="../../assets/logo.png"/>
    </div>

    <v-divider class="mb-1"/>

    <v-list dense nav style="position: relative">
      <base-item class="item-sidebar" :item="profile" />
    </v-list>

    <v-divider class="mb-2" />

    <v-list expand nav>
      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div />

      <template v-for="(item, i) in menuItems">
        <!-- -->
        <template v-if="showInSidebar(item.roles, item.title)">
          <base-item-group class="item-sidebar" v-if="item.children" :key="`group-${i}`"  :item="item">
            <!--  -->
          </base-item-group>

          <base-item v-else :key="`item-${i}`" :item="item" :class="item.to==''? 'classActive':''"/>
        </template>
      </template>

      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div />
    </v-list>
  </v-navigation-drawer>
</template>

<script>
const roleUsers = [
  'user_read',
  'user_create',
  'user_update',
  'user_delete',
  'user_view_all',
  'department_read',
  'department_create',
  'department_update',
  'department_delete',
  'kpi_read',
  'kpi_create',
  'kpi_update',
  'kpi_delete',
  'schedule_read',
  'schedule_create',
  'schedule_update',
  'schedule_delete',
  'schedule_view_all',
  'appointment_read',
  'appointment_create',
  'appointment_update',
  'appointment_delete',
  'appointment_view_all',
];
const roleCallCenter = [
  'call_center_read',
  'call_center_delete',
  'call_center_view_all',
  'general-call-center-report_read',
  'employee-call-center-report_read'
];

const roleReport = [
  'result-report_read',
  'employee-report_read',
  'status-report_read',
  'contact-source-report_read',
  'best-employee_read',
  'sale-leader_read',
  'product-group-revenue-report_read',
  'customer-revenue-report_read',
  'personal-report_read',
  'contact-register_read',
  'employee-report-a-department_read'
];
const roleDataSetting = [
  'contact-setting_read',
  'contact-setting_create',
  'contact-setting_update',
  'contact-setting_delete',
  'contact-source_read',
  'contact-source_create',
  'contact-source_update',
  'contact-source_delete',
  'contact-status_read',
  'contact-status_create',
  'contact-status_update',
  'contact-status_delete',
  'announcement_read',
  'announcement_create',
  'announcement_update',
  'announcement_delete'
];

const roleMktSms = [
    'mkt-sms-message_read',
    'mkt-sms-customer_read',
    'mkt-sms-message-history_read'
];

const roleSettingOrganization = [
  'setting-organization_read',
  'setting-organization_create',
  'setting-organization_update',
  'setting-organization_delete',
  'setting-role_read',
  'setting-role_create',
  'setting-role_update',
  'setting-role_delete',
  'user_read',
  'user_create',
  'user_update',
  'user_delete',
  'user_view_all',
  'setting-kpi_read',
  'setting-kpi_create',
  'setting-kpi_update',
  'setting-kpi_delete'
]

const roleMkt = [
  'marketing-report-by-marketer_read',
  'marketing-report-by-marketer-thpt_read',
  'marketing-report-by-content_read',
  'contact-register_read'
]

export const PARTNER = 'partner'

// Utilities
import { mapState } from 'vuex';
import TokenService from '../../helpers/token';
import { checkMobile } from '../../helpers/utils';
import RepositoryFactory from '../../repositories/RepositoryFactory';
const SchoolLevelRepository = RepositoryFactory.get('school_level')
const TypeRepository = RepositoryFactory.get('type')
export default {
  name: 'DashboardCoreDrawer',
  data: () => ({
    expandOnHover: true,
    filterForm: {
      typeId: '',
      schoolLevelId: ''
    },
    listPartnerCtv: [
      {
        name: 'CTV',
        code: 'ctv'
      },
      {
        name: 'Partner',
        code: 'partnert'
      }
    ],
    listSchoolLevel: [],
    listType: [],
    typeName: '',
    menuItems: [
      {
        to: '/orders',
        icon: 'mdi-account-cash',
        title: 'Payment Hub',
        roles: 'all',
      },
      {
        to: '/management',
        icon: 'mdi-clipboard-text',
        title: 'Quản lý đơn hàng',
        roles: 'all',
      },
      {
        to: '/products',
        icon: 'mdi-leaf',
        title: 'Quản lý sản phẩm',
        roles: 'all',
      },
      {
        to: '/campaign',
        icon: 'mdi-stack-overflow',
        title: 'Quản lý chiến dịch',
        roles: 'all',
      },
      {
        to: '/promotion',
        icon: 'mdi-leaf',
        title: 'Quản lý mã',
        roles: 'all',
      },
    ],
    profile: {
      avatar: true,
      avatarPath: TokenService.getAvatarPath(),
      group: '',
      title: TokenService.getFullName(),
      isManager: TokenService.getUser().isManager ? true : false,
      isCTV: TokenService.getUser().isCTV ? true : false,
      typeId: TokenService.getUser().typeId,
      schoolLevelId: TokenService.getUser().schoolLevelId,
      typeName: '',
      schoolLevelName: '',
      isMarketing: TokenService.getUser().isMarketing ? true : false,
    },
    isHover: true
  }),

  async created() {
    this.expandOnHover = !checkMobile()
    this.getFilterForm();
    Bus.$on('change-menu-side-bar', (filterForm) => {
      this.filterForm.schoolLevelId = filterForm.schoolLevelId
      this.filterForm.typeId = filterForm.typeId
    });
    this.getTypeNSchoolLevelName();
  },

  computed: {
    ...mapState(['barColor', 'barImage']),
    drawer: {
      get() {
        return this.$store.state.drawer;
      },
      set(val) {
        this.$store.commit('SET_DRAWER', val);
      }
    }
  },

  // watch: {
  //   '$vuetify.breakpoint.smAndDown'(val) {
  //     this.$emit('update:expandOnHover', !val);
  //   }
  // },

  methods: {
    mapItem(item) {
      return {
        ...item,
        children: item.children ? item.children.map(this.mapItem) : undefined,
        title: item.title
      };
    },
    async getListType() {
      if(!this.profile.isCTV) {

        if(this.$store.state.listType) {
          this.listType = _.cloneDeep(this.$store.state.listType);
        } else {
          const response = await TypeRepository.list();
          if (response.success) {
            this.listType = _.get(response, 'data', [])
            this.$store.dispatch('SET_LIST_TYPE', _.get(response, 'data', []))
          }
        }
        this.listType.push({
          name: 'Quản trị',
          id: ''
        });
        this.listType.push({
          id: 'partner',
          name: 'Đối tác'
        });

        // const response = await TypeRepository.list();
        // if (response.success) {
        //   this.listType = _.get(response, 'data', [])
        //   this.listType.push({
        //     name: 'Quản trị',
        //     id: ''
        //   });
        //   this.listType.push({
        //     id: 'partner',
        //     name: 'Đối tác'
        //   });
        // }
      }
    },
    async getListSchoolLevel() {

      if(this.$store.state.listSchoolLevel) {
        this.listSchoolLevel = _.cloneDeep(this.$store.state.listSchoolLevel)
        if(!this.filterForm.typeId) {
          this.listSchoolLevel.unshift({
            id: '',
            name: 'Tất cả'
          })
        }
        return
      }

      const loading = this.$loading.show()
      const params = {
        limit: 1000
      }
      const res = await SchoolLevelRepository.list(params)
      if (res.success) {
        this.listSchoolLevel = _.get(res, 'data', [])
        this.$store.dispatch('SET_LIST_SCHOOL_LEVEL', this.listSchoolLevel)
        if(!this.filterForm.typeId) {
          this.listSchoolLevel.unshift({
            id: '',
            name: 'Tất cả'
          })
        }
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi!',
          text: _.get(res, 'message', '')
        })
      }
      loading.hide()
    },
    getTypeNSchoolLevelName() {
      let indexType = this.listType.findIndex(ite => ite.id === this.filterForm.typeId);
      if(indexType > -1) {
        this.profile.typeName = this.listType[indexType].name
      }

      let indexSch = this.listSchoolLevel.findIndex(ite => ite.id === this.filterForm.schoolLevelId);
      if(indexSch > -1) {
        this.profile.schoolLevelName = this.listSchoolLevel[indexSch].name
      }
      // if((!this.profile.isManager && !this.profile.isCTV) || (this.profile.isManager && this.filterForm.typeId)) {
      //   this.menuItems[1].title = `Dashboard ${this.profile.typeName}`;
      // }
    },
    getFilterForm() {
      const user = TokenService.getUser();
      this.isManager = user.isManager
      if(user.isManager) {
        this.filterForm.typeId = this.$store.state.module.typeId ? this.$store.state.module.typeId : ''
        this.filterForm.schoolLevelId = this.$store.state.module.schoolLevelId ? this.$store.state.module.schoolLevelId : ''
      } else {
        this.filterForm.typeId = user.typeId
        this.filterForm.schoolLevelId = user.schoolLevelId
      }
    }
  }
};
</script>

<style lang="sass">
  @import '~vuetify/src/styles/tools/_rtl.sass'

  #core-navigation-drawer
    &.v-navigation-drawer--mini-variant
      .v-list-item
        justify-content: flex-start !important

      .v-list-group--sub-group
        display: block !important

      .v-navigation-drawer__content
        overflow-y: hidden
        background: rgb(21, 21, 21, 0.66)

    &.v-navigation-drawer--is-mouseover
      .v-navigation-drawer__content
        overflow-y: auto
        background: rgb(21, 21, 21, 0.66)

    .v-list-group__header.v-list-item--active:before
      opacity: .24

    .v-list-item
      &__icon--text,
      &__icon:first-child
        justify-content: center
        text-align: center
        width: 20px

        +ltr()
          margin-right: 24px
          margin-left: 12px !important

        +rtl()
          margin-left: 24px
          margin-right: 12px !important

    .v-list--dense
      .v-list-item
        &__icon--text,
        &__icon:first-child
          margin-top: 10px

    .v-list-group--sub-group
      .v-list-item
        +ltr()
          padding-left: 8px

        +rtl()
          padding-right: 8px

      .v-list-group__header
        +ltr()
          padding-right: 0

        +rtl()
          padding-right: 0

        .v-list-item__icon--text
          margin-top: 19px
          order: 0

        .v-list-group__header__prepend-icon
          order: 2

          +ltr()
            margin-right: 8px

          +rtl()
            margin-left: 8px
</style>
<style lang="css">
  /deep/ .v-text-field > .v-input__control > .v-input__slot:before {
    border-style: none;
  }
  a.v-list-item.v-list-item--link.theme--light.classActive .v-list-item__title {
    font-weight: 900;
  }
  .title-module-sale {
    position: absolute;
    bottom: 13px;
    left: 74px;
    color: #FFFFFF;
    font-weight: 600;
  }
  .title-module-sale.no-manager {
    max-height: 25px;
  }
  .title-module-sale .v-select:not(.v-text-field--single-line):not(.v-text-field--outlined) .v-select__slot > input {
    color: #FFFFFF !important;
    font-weight: bold;
  }
  a.item-sidebar .v-list-item__content {
    position: absolute;
    left: 60px;
    top: 2px;
  }
  .v-divider {
    border-color: rgb(255 255 255 / 12%)!important
  }
  .wrapper-is-manager .v-text-field > .v-input__control > .v-input__slot:after {
    border: none !important;
  }
  .wrapper-is-manager .theme--light.v-text-field:not(.v-input--has-state) > .v-input__control > .v-input__slot:hover:before {
    border: none !important;
  }
  .wrapper-is-manager .theme--light.v-text-field > .v-input__control > .v-input__slot:before {
    border: none !important;
  }

  #core-navigation-drawer .item-sidebar .v-list-group__items .v-list-item__icon--text {
    visibility: hidden !important;
  }
  .v-navigation-drawer__content{
    background: #191919!important;
  }
  .title-module-sale.no-manager {
    display: none;
  }
  #core-navigation-drawer:hover .title-module-sale.no-manager {
    display: unset;
  }
</style>
